import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0bf39ebc = () => interopDefault(import('../pages/aboutus.vue' /* webpackChunkName: "pages/aboutus" */))
const _1ffc74f7 = () => interopDefault(import('../pages/cipp-offer/index.vue' /* webpackChunkName: "pages/cipp-offer/index" */))
const _55094540 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _da47a672 = () => interopDefault(import('../pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _5b853ab6 = () => interopDefault(import('../pages/business/analytics.vue' /* webpackChunkName: "pages/business/analytics" */))
const _409d3b06 = () => interopDefault(import('../pages/business/communication.vue' /* webpackChunkName: "pages/business/communication" */))
const _6b0af7a5 = () => interopDefault(import('../pages/business/membersupport.vue' /* webpackChunkName: "pages/business/membersupport" */))
const _3930f656 = () => interopDefault(import('../pages/dashboard/combine.vue' /* webpackChunkName: "pages/dashboard/combine" */))
const _37ed6364 = () => interopDefault(import('../pages/dashboard/documents.vue' /* webpackChunkName: "pages/dashboard/documents" */))
const _279095ad = () => interopDefault(import('../pages/dashboard/landing.vue' /* webpackChunkName: "pages/dashboard/landing" */))
const _50ddd4ac = () => interopDefault(import('../pages/dashboard/nextsteps.vue' /* webpackChunkName: "pages/dashboard/nextsteps" */))
const _b6278ce4 = () => interopDefault(import('../pages/dashboard/report.vue' /* webpackChunkName: "pages/dashboard/report" */))
const _0772cd56 = () => interopDefault(import('../pages/dashboard/reports.vue' /* webpackChunkName: "pages/dashboard/reports" */))
const _6d78e8d3 = () => interopDefault(import('../pages/dashboard/retirement.vue' /* webpackChunkName: "pages/dashboard/retirement" */))
const _06950f57 = () => interopDefault(import('../pages/dashboard/review-choices.vue' /* webpackChunkName: "pages/dashboard/review-choices" */))
const _3028aa14 = () => interopDefault(import('../pages/dashboard/selected-funds.vue' /* webpackChunkName: "pages/dashboard/selected-funds" */))
const _41004e16 = () => interopDefault(import('../pages/dashboard/selfhelpdirectory.vue' /* webpackChunkName: "pages/dashboard/selfhelpdirectory" */))
const _559ba87d = () => interopDefault(import('../pages/dashboard/settings.vue' /* webpackChunkName: "pages/dashboard/settings" */))
const _2defbd1e = () => interopDefault(import('../pages/dashboard/shortlist-funds.vue' /* webpackChunkName: "pages/dashboard/shortlist-funds" */))
const _34209916 = () => interopDefault(import('../pages/onboarding/annuity-options.vue' /* webpackChunkName: "pages/onboarding/annuity-options" */))
const _9a0aebf8 = () => interopDefault(import('../pages/onboarding/authorization.vue' /* webpackChunkName: "pages/onboarding/authorization" */))
const _ee9ec910 = () => interopDefault(import('../pages/onboarding/avc-information.vue' /* webpackChunkName: "pages/onboarding/avc-information" */))
const _ce2f14ea = () => interopDefault(import('../pages/onboarding/checkout.vue' /* webpackChunkName: "pages/onboarding/checkout" */))
const _391d63ba = () => interopDefault(import('../pages/onboarding/employment-info.vue' /* webpackChunkName: "pages/onboarding/employment-info" */))
const _0f1f9374 = () => interopDefault(import('../pages/onboarding/final-salary.vue' /* webpackChunkName: "pages/onboarding/final-salary" */))
const _795fe809 = () => interopDefault(import('../pages/onboarding/fund-selection.vue' /* webpackChunkName: "pages/onboarding/fund-selection" */))
const _7f55c3f4 = () => interopDefault(import('../pages/onboarding/login.vue' /* webpackChunkName: "pages/onboarding/login" */))
const _2527bf6f = () => interopDefault(import('../pages/onboarding/login-error.vue' /* webpackChunkName: "pages/onboarding/login-error" */))
const _7844044f = () => interopDefault(import('../pages/onboarding/my-tax-liability.vue' /* webpackChunkName: "pages/onboarding/my-tax-liability" */))
const _2669dcd4 = () => interopDefault(import('../pages/onboarding/other-pot-addition.vue' /* webpackChunkName: "pages/onboarding/other-pot-addition" */))
const _f1e532e4 = () => interopDefault(import('../pages/onboarding/pension-details.vue' /* webpackChunkName: "pages/onboarding/pension-details" */))
const _764d2649 = () => interopDefault(import('../pages/onboarding/pension-provider-by-name.vue' /* webpackChunkName: "pages/onboarding/pension-provider-by-name" */))
const _d1615eb4 = () => interopDefault(import('../pages/onboarding/personal-info.vue' /* webpackChunkName: "pages/onboarding/personal-info" */))
const _217be2fc = () => interopDefault(import('../pages/onboarding/redeem-voucher.vue' /* webpackChunkName: "pages/onboarding/redeem-voucher" */))
const _469ecb44 = () => interopDefault(import('../pages/onboarding/reset-password.vue' /* webpackChunkName: "pages/onboarding/reset-password" */))
const _2f5b5209 = () => interopDefault(import('../pages/onboarding/scheme-information.vue' /* webpackChunkName: "pages/onboarding/scheme-information" */))
const _b41d3264 = () => interopDefault(import('../pages/onboarding/success.vue' /* webpackChunkName: "pages/onboarding/success" */))
const _3741e0a2 = () => interopDefault(import('../pages/onboarding/suez-info.vue' /* webpackChunkName: "pages/onboarding/suez-info" */))
const _82e137d8 = () => interopDefault(import('../pages/onboarding/tax-payment-methods.vue' /* webpackChunkName: "pages/onboarding/tax-payment-methods" */))
const _7fc1ab46 = () => interopDefault(import('../pages/personal/account.vue' /* webpackChunkName: "pages/personal/account" */))
const _0a5e5278 = () => interopDefault(import('../pages/personal/nextsteps.vue' /* webpackChunkName: "pages/personal/nextsteps" */))
const _9b9d6a0e = () => interopDefault(import('../pages/personal/retirement.vue' /* webpackChunkName: "pages/personal/retirement" */))
const _1953559c = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _5d6d593a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aboutus",
    component: _0bf39ebc,
    name: "aboutus"
  }, {
    path: "/cipp-offer",
    component: _1ffc74f7,
    name: "cipp-offer"
  }, {
    path: "/help",
    component: _55094540,
    name: "help"
  }, {
    path: "/verify-email",
    component: _da47a672,
    name: "verify-email"
  }, {
    path: "/business/analytics",
    component: _5b853ab6,
    name: "business-analytics"
  }, {
    path: "/business/communication",
    component: _409d3b06,
    name: "business-communication"
  }, {
    path: "/business/membersupport",
    component: _6b0af7a5,
    name: "business-membersupport"
  }, {
    path: "/dashboard/combine",
    component: _3930f656,
    name: "dashboard-combine"
  }, {
    path: "/dashboard/documents",
    component: _37ed6364,
    name: "dashboard-documents"
  }, {
    path: "/dashboard/landing",
    component: _279095ad,
    name: "dashboard-landing"
  }, {
    path: "/dashboard/nextsteps",
    component: _50ddd4ac,
    name: "dashboard-nextsteps"
  }, {
    path: "/dashboard/report",
    component: _b6278ce4,
    name: "dashboard-report"
  }, {
    path: "/dashboard/reports",
    component: _0772cd56,
    name: "dashboard-reports"
  }, {
    path: "/dashboard/retirement",
    component: _6d78e8d3,
    name: "dashboard-retirement"
  }, {
    path: "/dashboard/review-choices",
    component: _06950f57,
    name: "dashboard-review-choices"
  }, {
    path: "/dashboard/selected-funds",
    component: _3028aa14,
    name: "dashboard-selected-funds"
  }, {
    path: "/dashboard/selfhelpdirectory",
    component: _41004e16,
    name: "dashboard-selfhelpdirectory"
  }, {
    path: "/dashboard/settings",
    component: _559ba87d,
    name: "dashboard-settings"
  }, {
    path: "/dashboard/shortlist-funds",
    component: _2defbd1e,
    name: "dashboard-shortlist-funds"
  }, {
    path: "/onboarding/annuity-options",
    component: _34209916,
    name: "onboarding-annuity-options"
  }, {
    path: "/onboarding/authorization",
    component: _9a0aebf8,
    name: "onboarding-authorization"
  }, {
    path: "/onboarding/avc-information",
    component: _ee9ec910,
    name: "onboarding-avc-information"
  }, {
    path: "/onboarding/checkout",
    component: _ce2f14ea,
    name: "onboarding-checkout"
  }, {
    path: "/onboarding/employment-info",
    component: _391d63ba,
    name: "onboarding-employment-info"
  }, {
    path: "/onboarding/final-salary",
    component: _0f1f9374,
    name: "onboarding-final-salary"
  }, {
    path: "/onboarding/fund-selection",
    component: _795fe809,
    name: "onboarding-fund-selection"
  }, {
    path: "/onboarding/login",
    component: _7f55c3f4,
    name: "onboarding-login"
  }, {
    path: "/onboarding/login-error",
    component: _2527bf6f,
    name: "onboarding-login-error"
  }, {
    path: "/onboarding/my-tax-liability",
    component: _7844044f,
    name: "onboarding-my-tax-liability"
  }, {
    path: "/onboarding/other-pot-addition",
    component: _2669dcd4,
    name: "onboarding-other-pot-addition"
  }, {
    path: "/onboarding/pension-details",
    component: _f1e532e4,
    name: "onboarding-pension-details"
  }, {
    path: "/onboarding/pension-provider-by-name",
    component: _764d2649,
    name: "onboarding-pension-provider-by-name"
  }, {
    path: "/onboarding/personal-info",
    component: _d1615eb4,
    name: "onboarding-personal-info"
  }, {
    path: "/onboarding/redeem-voucher",
    component: _217be2fc,
    name: "onboarding-redeem-voucher"
  }, {
    path: "/onboarding/reset-password",
    component: _469ecb44,
    name: "onboarding-reset-password"
  }, {
    path: "/onboarding/scheme-information",
    component: _2f5b5209,
    name: "onboarding-scheme-information"
  }, {
    path: "/onboarding/success",
    component: _b41d3264,
    name: "onboarding-success"
  }, {
    path: "/onboarding/suez-info",
    component: _3741e0a2,
    name: "onboarding-suez-info"
  }, {
    path: "/onboarding/tax-payment-methods",
    component: _82e137d8,
    name: "onboarding-tax-payment-methods"
  }, {
    path: "/personal/account",
    component: _7fc1ab46,
    name: "personal-account"
  }, {
    path: "/personal/nextsteps",
    component: _0a5e5278,
    name: "personal-nextsteps"
  }, {
    path: "/personal/retirement",
    component: _9b9d6a0e,
    name: "personal-retirement"
  }, {
    path: "/blog/:slug?",
    component: _1953559c,
    name: "blog-slug"
  }, {
    path: "/",
    component: _5d6d593a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
